import { encodeFunctionData } from 'viem'

import { ContractWriteParams, GasFeeMetrics, GasFeeSimulationResults } from '@src/types/gasFees'
import { isEVMAddress, isTronAddress } from '@src/utils/address'
import { TronConverter } from '@src/utils/tron/tronAddressConverter'
import { estimateTronEnergyUsage } from '@src/utils/tron/utils'

export async function simulateTronGasFees(
    transactions: ContractWriteParams[],
    gasFeeMetrics: GasFeeMetrics
): Promise<GasFeeSimulationResults> {
    let totalEnergy = BigInt(0)
    let totalBandWidth = BigInt(0)

    // Process each transaction
    for (const tx of transactions) {
        const correctedParams = tx.functionParams.map(p => {
            if (p.type === 'address') {
                if (isEVMAddress(p.value as string)) {
                    return p
                } else if (isTronAddress(p.value as string)) {
                    return {
                        type: 'address',
                        value: TronConverter.toHex(p.value as string),
                    }
                } else {
                    throw new Error(`Wrong address value encountered: ${p.value}`)
                }
            }
            return p
        })

        const encodedData = encodeFunctionData({
            abi: [
                {
                    type: 'function',
                    name: tx.functionSignature.split('(')[0],
                    inputs: tx.functionParams.map(p => ({ type: p.type })),
                },
            ],
            functionName: tx.functionSignature.split('(')[0],
            args: correctedParams.map(p => p.value),
        })

        const bandWidth = BigInt(Math.floor((encodedData.length - 2) / 2))
        const gasEstimate = await estimateTronEnergyUsage(
            tx.contractAddress as string,
            tx.functionSignature,
            correctedParams,
            true,
            tx.caller
        )

        totalEnergy += BigInt(gasEstimate)
        totalBandWidth += bandWidth
    }

    return {
        totalGasUnits: BigInt(0),
        individualGasUnits: [BigInt(0)],
        totalFeePerGasUnit: BigInt(0),
        feeMetrics: gasFeeMetrics,
        tronResults: {
            totalEnergyUsed: totalEnergy,
            totalBandWidthUsed: totalBandWidth,
        },
    }
}
